import { useSelector } from "react-redux";

import { Case } from "@types-runway/case";
import { Condition } from "@types-runway/condition";
import {
  AnswerType,
  EntityType,
  NoticeMessage,
  QuestionDependency,
  QuestionnaireContext,
  StoragePath,
  WarningMessage,
} from "@types-runway/questionnaire";
import { RootState } from "@types-runway/state";
import { User } from "@types-runway/user";
import {
  displayWarningMessage as displayWarningMessagePure,
  getQuestionDependencyMatch as getQuestionDependencyMatchPure,
  getUsersAge,
  isValidAnswer,
  questionIsAlreadyAsked as questionIsAlreadyAskedPure,
} from "@utils/questionnaire/validation";

export const useQuestionValidation = () => {
  const user = useSelector<RootState, User>((state) => state.user.data);
  const newCase = useSelector<RootState, Case>((state) => state.case.newCase.data);

  const displayWarningMessage = (
    answer: AnswerType,
    warningMessage?: WarningMessage,
    conditions?: Condition[]
  ): NoticeMessage | null => {
    return displayWarningMessagePure(answer, warningMessage, {
      conditions: conditions ?? newCase.conditions,
      dateOfBirth: user.date_of_birth?.toString() ?? "",
    });
  };

  const getQuestionDependencyMatch = (
    dependency: QuestionDependency,
    context: QuestionnaireContext
  ): boolean => {
    return getQuestionDependencyMatchPure(dependency, {
      ...context,
      dateOfBirth: user.date_of_birth?.toString() ?? "",
      conditions: newCase.conditions,
    });
  };

  const questionIsAlreadyAsked = (storagePath: StoragePath<EntityType>[]): boolean => {
    return questionIsAlreadyAskedPure(storagePath, user);
  };

  return {
    getUsersAge,
    isValidAnswer,
    displayWarningMessage,
    getQuestionDependencyMatch,
    questionIsAlreadyAsked,
  };
};
